import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { Checkbox, Radio } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { GrappleModule } from "../../../interfaces/api/GrappleModule";
import { Rototilt } from "../../../interfaces/api/Rototilt";
import { ListObject } from "../../../shared/types/ListObject";
import "./ListTable.scss";

export enum ListSelectMode {
  None = -1,
  Single = 0,
  Multi = 1,
  AddRemove = 2,
  Config = 3,
}

interface ListRowProps {
  children: ReactNode;
  configLink?: string;
  isSelected: boolean;
  identifier: string;
  object: GrappleModule | ListObject | Rototilt;
  onChange(object: GrappleModule | ListObject | Rototilt): void;
  selectMode?: ListSelectMode;
}

const ListRow = ({
  children,
  configLink,
  isSelected,
  identifier,
  object,
  onChange,
  selectMode = ListSelectMode.Single,
}: ListRowProps) => {
  const fontSize = 18;

  return (
    <div 
      key={identifier} 
      className="listItem"
      onClick={() => {
        if (selectMode !== ListSelectMode.Config) {
          onChange(object);
        }
      }}
      style={{ cursor: selectMode !== ListSelectMode.Config ? "pointer" : "default" }}
    >
      <div className="listItemRow">{children}</div>
      <div className="listItemSelection">
        {selectMode === ListSelectMode.Single && (
          <Radio
            checked={isSelected}
            readOnly
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize,
              },
              pointerEvents: "none",
            }}
          />
        )}
        {selectMode === ListSelectMode.Multi && (
          <Checkbox
            checked={isSelected}
            readOnly
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize,
              },
              pointerEvents: "none",
            }}
          />
        )}
        {selectMode === ListSelectMode.Config && (
          <RouterLink to={configLink}>
            <button className="listItemButtonConfig">
              <ModeEditOutlineOutlinedIcon />
            </button>
          </RouterLink>
        )}
      </div>
    </div>
  );
};

export default ListRow;
